import * as tslib_1 from "tslib";
import { Component } from '../common/component';
var Container = /** @class */ (function (_super) {
    tslib_1.__extends(Container, _super);
    function Container(param) {
        return _super.call(this, param) || this;
    }
    Container.prototype.toJSON = function () {
        return Object.assign({}, _super.prototype.toJSON.call(this), { "type": "Container" });
    };
    Container.prototype.toString = function () {
        return JSON.stringify(this.toJSON());
    };
    return Container;
}(Component));
export { Container };
//# sourceMappingURL=container.js.map